export default "__VITE_ASSET__DN$N$S7z__"